import React, { useEffect, useState } from 'react'
import axios from 'axios'


// const token = user?.token;
// const headers = {
//   "Content-Type": "application/json",
//   Authorization: `Bearer ${token}`,
//   "ngrok-skip-browser-warning": "skip-browser-warning",
// };

const CommentTile = ({ patientComment }) => {
  return (
    <div className="w-full flex justify-start items-start gap-2">
      <div>
        <div className="rounded-full bg-[#415da1] text-white w-12 h-12 flex justify-center items-center p-3">
          <p className="text-lg font-medium uppercase">
            {patientComment?.created_by?.first_name?.[0] +
              patientComment.created_by?.last_name?.[0]}
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="gap-2 flex items-center">
          <p className="font-medium">
            {patientComment?.created_by?.title +" "+ patientComment?.created_by?.first_name +
              " " +
              patientComment.created_by?.last_name}
          </p>
          <p className="text-gray-400 text-xs capitalize">
            {patientComment?.created_by?.practice_name}
          </p>
        </div>
        <div className="w-full">
          <p className="text-sm w-full">{patientComment?.comment}</p>
        </div>
        <div>
          <p className="text-gray-400 text-xs">{patientComment?.created_at.split(' ')[0]}</p>
        </div>
      </div>
    </div>
  );
};



const CommentsSection = ({ id }) => {
  const user = JSON.parse(localStorage.getItem("userData"));
  const [commentsData, setCommentsData] = useState([])
  const [commentInput, setCommentInput] = useState("")
  const [loading, setLoading] = useState(false)

  const fetchPatientComments = () => {
    axios.post(`${process.env.REACT_APP_API_URL}api/v1/getcommentsbypatientid`, { patient_id: id }, {withCredentials:true})
      .then((response) => {
        setCommentsData(response?.data?.data?.commentdata);
      })
      .catch((error) => {
        console.log("Network error:", error);
      });
  };

  const handleSubmitComment = (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      patient_id: id,
      comment: commentInput,
      created_by: user?.id,
    };
    axios.post(`${process.env.REACT_APP_API_URL}api/v1/addcomments`, payload, {withCredentials:true})
    .then((response) => {
      setLoading(false)
      console.log("response from comment submit: ", response?.data)
      setCommentInput("")

      fetchPatientComments()
    })
    .catch((error) => {
      console.log("error while submitting comment: ", error)
      setLoading(false);
    })
  }
  
  useEffect(() => {
    fetchPatientComments();
  },[])
  return (
    <div className="rounded-md shadow-md border border-gray-300 w-full p-3 flex flex-col gap-4 max-h-[60vh]">
    <form onSubmit={handleSubmitComment} className="w-full flex gap-2 justify-start items-start">
        <textarea
          name=""
          id=""
          className="w-full border border-gray-300 outline-none p-2 text-sm rounded-md"
          rows={1}
          placeholder="Enter comment here..."
          onChange={(e) => setCommentInput(e?.target?.value)}
          value={commentInput}
          required
        />
        <div className="flex justify-end items-center">
          <button
            className={`p-1 text-xl rounded-md bg-black text-white flex justify-center items-center h-[38px] w-[38px]`}
            disabled={loading}
            type='submit'
          >
            {loading ? (
              
                <svg
                  aria-hidden="true"
                  className="inline w-5 h-5 text-white animate-spin  fill-primary"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
            ) : (
              <p>+</p>
            )}
          </button>
        </div>
      </form>
      <div className="w-full flex flex-col gap-5 overflow-y-auto">
        {commentsData?.map((item, index) => (
          <CommentTile patientComment={item} key={index} />
        ))}
      </div>
    </div>
  );
}

export default CommentsSection